import officeApiCallAsync from './office-api-call-async'

export default async function officeApiExecAsync(
  requirementSet: string,
  apiMethodName: string,
  apiMethodAsync: () => Promise<Office.AsyncResult<void>>,
): Promise<boolean> {
  const asyncResult = await officeApiCallAsync<Office.AsyncResult<void>>(requirementSet, apiMethodName, apiMethodAsync)

  if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
    return true
  } else {
    throw asyncResult.error
  }
}
